'use client';

import ResponsiveImage from "@/components/elements/images/ResponsiveImage/ResponsiveImage";
import LinkButton from "@/components/elements/links/LinkButton/LinkButton";
import useFetchShopDetail from "@/hooks/useFetchShopDetail.hooks";
import { Suspense } from "react";
import { MicroCMSGetAuthes } from "../../_configs/MicroCMSConfig";
import styles from "./ShopInfoBox.module.scss";
import { ShopInfoBoxType } from "./ShopInfoBoxType";

const ShopInfoBox = (props: ShopInfoBoxType) => {
  const {shopId, shopInfo, linkItem} = props;
  const endpointId = "shops";
  const microCMSAuth = MicroCMSGetAuthes["shop"];
  // console.log("microCMSAuth: " + microCMSAuth);

  const {isLoading, response, hasError, errorMessage} = useFetchShopDetail(shopId, endpointId, microCMSAuth);

  return(
    <Suspense>
      {response && 
        <div className={styles.shopInfoBox}>
          <div className={styles.shopInfoBox__img}>
            <ResponsiveImage 
              srcPC={shopInfo.coverPicture.srcPC}
              srcSP={shopInfo.coverPicture.srcSP}
              altText={shopInfo.coverPicture.altText}
            />
          </div>
          <div className={styles.shopInfoBox__text}>
            <h4 className={styles.shopInfoBox__text__title}>{response.name}</h4>
            <dl className={styles.shopInfoBox__text__info}>
              <div className={styles.shopInfoBox__text__info__inner}>
                <dt>住　　所</dt>
                <dd>{response.address}</dd>
              </div>
              <div className={styles.shopInfoBox__text__info__inner}>
                <dt>電話番号</dt>
                <dd>{response.tel}</dd>
              </div>
              <div className={styles.shopInfoBox__text__info__inner}>
                <dt>営業時間</dt>
                <dd>
                  午前 {response.shinryo.openAM} {response.shinryo.openAMBikou && <>({response.shinryo.openAMBikou})</> }
                  <br />
                  午後 {response.shinryo.openPM} {response.shinryo.openPMBikou && <>({response.shinryo.openPMBikou})</> }
                  <br />
                </dd>
              </div>
              <div className={styles.shopInfoBox__text__info__inner}>
                <dt>定休日</dt>
                  <dd>
                    {response.closed ? response.closed : "-"}
                  </dd>
              </div>
            </dl>
            {response.features && 
              <ul className={styles.shopInfoBox__features}>
                {response.features.map((item: string, key: number) => (
                  <li key={key} data-icon={item}>
                    {item}
                  </li>
                ))}
              </ul>
            }
            <div className={styles.shopInfoBox__text__link}>
              <LinkButton 
                linkTo={linkItem.linkTo}
                linkText={linkItem.linkText}
                isExternal={linkItem.isExternal}
              />
            </div>
          </div>
        </div>
      }
    </Suspense>
  )
}
export default ShopInfoBox;